import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) {

  }


  getListTimesheetPerYear(param: any) {
    let params = new HttpParams();
    params = params.append('isvendor', param.isvendor);
    params = params.append('year',  param.YEAR);
    if (param.vendor != null && param.vendor?.length > 0) {
      params = params.append('vendor', param.vendor);
    }
    if (param.resourceId != null && param.resourceId?.length > 0) {
      params = params.append('resourceId', param.resourceId);
    }
    return this.http.get(`${environment.api_cm_reports}/listTimesheetPerYear`, { params: params })
      .pipe(map(data => data));
  }

  listTimesheetDetPerYear(param: any) {
    let params = new HttpParams();
    params = params.append('isvendor', param.isvendor);
    params = params.append('year',  param.YEAR);
    params = params.append('month',  param.MONTH);
    if (param.vendor != null && param.vendor?.length > 0) {
      params = params.append('vendor', param.vendor);
    }
    if (param.resourceId != null && param.resourceId?.length > 0) {
      params = params.append('resourceId', param.resourceId);
    }
    return this.http.get(`${environment.api_cm_reports}/listTimesheetDetPerYear`, { params: params })
      .pipe(map(data => data));
  }

  /**
   *
   * @param vendor
   * @returns
   */
  getListPoNumber(vendor: string) {
    let params = new HttpParams();
    params = params.append('vendor', vendor);
    return this.http.get(`${environment.api_cm_reports}/listPoNumber`, { params: params })
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  saveReceipts(param: any) {
    return this.http.post(`${environment.api_cm_reports}/saveReceipts`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListReceipts(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_reports}/listReceipts`, { params: params })
      .pipe(map(data => data));
  }

}
